import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { Box } from "@mm/ui";
import { LoadingOverlay, PageHeader, PageFooter } from "@/components/organisms";
import { InternetServiceProvider, InternetFilter, InternetHero, InternetTeaserRegards, InternetInfoBox, InternetIntroText, InternetOfferGroupsTeaser, ImageBanner, } from "@/sections";
import { StandardPageTemplate } from "@/components/templates";
import { usePage } from "@/utils/fetchData";
import { Loading } from "@/components/molecules";
import { InternetProvider } from "@/features/Internet";
import PageSections from "@/pages/PageSections";
import { useLocation } from "react-router-dom";
import dataLayer from "@/helper/dataLayer";
const InternetPage = () => {
    const { data: page } = usePage();
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    useEffect(() => {
        if (page) {
            dataLayer({
                pageType: "Landingpage",
                category: "DSL",
            });
        }
    }, [page]);
    if (!page)
        return _jsx(Loading, { variant: "home" });
    window.DY.recommendationContext = {
        type: "CATEGORY",
        lng: "de_DE",
        data: ["internet"],
    };
    const VodafoneImageBanner = ({ isLink }) => {
        return (_jsx(ImageBanner, { data: {
                linkUrl: isLink
                    ? window.location.origin + "/dsl-und-internet/vodafone/"
                    : "",
                imageAltText: "Sichere dir Prämien im Wert von 850€ mit dem GigaZuhause 1000 Kabel Plus Tarif",
                images: {
                    lgUrl: "/img/internet/vodafone/banner/1104x196.png",
                    mdUrl: "/img/internet/vodafone/banner/946x254.png",
                    smUrl: "/img/internet/vodafone/banner/700x251.png",
                    xlUrl: "/img/internet/vodafone/banner/1104x236.png",
                    xsUrl: "/img/internet/vodafone/banner/478x249.png",
                },
            } }));
    };
    return (_jsx(InternetProvider, { page: page, children: _jsx(StandardPageTemplate, { header: _jsx(PageHeader, { itemCount: 1 }), sections: [
                _jsx(InternetHero, {}, "InternetHero"),
                _jsx(InternetTeaserRegards, { layout: page.name === "Vodafone" ? "" : "" }, "InternetTeaserRegards"),
                page.internet.serviceProvider.length === 0 && (_jsxs(_Fragment, { children: [_jsx(Box, { mb: 4, children: _jsx(VodafoneImageBanner, { isLink: true }) }), _jsx(InternetServiceProvider, {}, "InternetServiceProvider")] })),
                page.name === "Vodafone" && (_jsxs(_Fragment, { children: [_jsx(VodafoneImageBanner, {}), _jsx(InternetIntroText, {}, "InternetIntroText"), _jsx(InternetInfoBox, { variant: "" }, "InternetInfoBox")] })),
                _jsx(InternetFilter, {}, "InternetFilter"),
                _jsx(InternetOfferGroupsTeaser, {}, "InternetOfferGroupsTeaser"),
                _jsx(Box, { mb: 4 }, "Box"),
                _jsx(PageSections, { sections: page.sections, variant: page.siteType }, "PageSections"),
                _jsx(LoadingOverlay, {}, "LoadingOverlay"),
            ], footer: _jsx(PageFooter, {}) }) }));
};
export default InternetPage;
